<template>
  <div
    class="absolute flex cursor-auto left-0 z-10 mt-2 origin-top-right border rounded-md bg-white shadow ring-1 ring-black ring-opacity-5 focus:outline-none"
    style="min-width: 410px !important"
  >
    <div class="p-1 flex grow flex-1">
      <div v-if="oldListReadable.length" class="p-2 flex-1">
        <span
          v-for="obj in oldListReadable"
          :key="getId(obj)"
          class="flex items-center truncate"
          :class="obj.wasRemoved && 'text-red-600 font-medium'"
        >
          <svg v-if="obj.wasRemoved" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3">
            <path fill-rule="evenodd" d="M5.25 12a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z" clip-rule="evenodd" />
          </svg>

          <span class="-mb-0.5">{{ obj.name }}</span>
        </span>
      </div>
      <div v-else class="text-gray-400 flex-1 flex justify-center items-center"><h2 class="text-base m-0">Empty list</h2></div>

      <div class="divide p-1"></div>

      <div v-if="newListReadable.length" class="p-2 flex-1">
        <span
          v-for="obj in newListReadable"
          :key="getId(obj)"
          class="flex items-center truncate"
          :class="obj.isNew && 'text-green-600 font-medium'"
        >
          <svg v-if="obj.isNew" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
          </svg>

          <span class="-mb-0.5">{{ obj.name }}</span>
        </span>
      </div>
      <div v-else class="text-gray-400 flex-1 flex justify-center items-center"><h2 class="text-base m-0">Empty list</h2></div>
    </div>
  </div>
</template>

<script>

import { difference } from "lodash"

export default {
  props: {
    extractMostImportantReadableField: Function,
    value: {},
    old: {},
  },
  methods: {
    isObj(val) {
      return !Array.isArray(val) && typeof val === 'object' && val !== null
    },
    getId(obj) {
      return obj.uid || obj.id || obj.sku || obj.external_id
    },
    isSame(val, old) {
      if (this.isObj(val) && this.isObj(old)) {
        return this.getId(val) === this.getId(old)
      }

      return val === old
    },
    parseJsonIfPossible(val) {
      if (typeof val !== "string") return val
      try {
        return JSON.parse(val)
      } catch (err) {
        return val
      }
    },
    mapIdToValue(id) {
      return this.all.find(val => this.getId(val) === id)
    },
  },
  computed: {
    all() {
      return [...this.validValue, ...this.validOld]
    },
    newValues() {
      return difference(this.validValue.map(this.getId), this.validOld.map(this.getId)).map(this.mapIdToValue)
    },
    removedValues() {
      return difference(this.validOld.map(this.getId), this.validValue.map(this.getId)).map(this.mapIdToValue)
    },
    validValue() {
      return this.parseJsonIfPossible(this.value) || []
    },
    validOld() {
      return this.parseJsonIfPossible(this.old) || []
    },
    newListReadable() {
      const newValues = this.newValues
      return this.validValue
        .map(obj => ({
          isNew: newValues.some(val => this.isSame(val, obj)),
          name: this.extractMostImportantReadableField(obj),
        }))
    },
    oldListReadable() {
      const removedValues = this.removedValues
      return this.validOld
        .map(obj => ({
          wasRemoved: removedValues.some(val => this.isSame(val, obj)),
          name: this.extractMostImportantReadableField(obj),
        }))
    },
  },
}

</script>

<style scoped>

.divide {
  border-left: 1px solid rgb(220,220,220);
}

.truncate {
  max-width: 180px;
}

</style>
